import FormTitle from '@core/components/FormTitle';
import { TextInput, TextLabel } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Tooltip,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { MdHighlightOff } from 'react-icons/md';
import faturamentoApi from '../../../../../services/api/faturamentoApi';
import RecebimentoDiferentePrimeiraCobranca from './RecebimentoDiferentePrimeiraCobranca';
import { pagamentoContratoStyles } from './styles';

const PagamentoContrato = ({ values, handleChange, handleBlur, errors }) => {
  const styles = pagamentoContratoStyles();
  const [faturamentoAutomatico, setFaturamentoAutomatico] = useState(false);
  const [openTooltipEnvioAutomatico, setOpenTooltipEnvioAutomatico] = useState(false);
  const [openTooltipEnvioNF, setOpenTooltipEnvioNF] = useState(false);

  const getCurrency = (value) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('R$', '');

  useEffect(() => {
    const isAutomatico = async () => {
      const automatico = await faturamentoApi.faturamentoAutomaticoContrato();
      setFaturamentoAutomatico(automatico.data);
    };
    isAutomatico();
  }, []);

  const handleCloseAutomatico = () => {
    setOpenTooltipEnvioAutomatico(false);
  };

  const handleOpenAutomatico = () => {
    setOpenTooltipEnvioAutomatico(true);
  };

  const handleCloseNF = () => {
    setOpenTooltipEnvioNF(false);
  };

  const handleOpenNF = () => {
    setOpenTooltipEnvioNF(true);
  };

  const addEmail = () => {
    const { emailsCliente } = values;
    emailsCliente.push({ email: '', principal: false });

    handleChange({ target: { id: `emailsCliente${emailsCliente.length}`, values: '' } });
  };

  const removeEmail = (index) => {
    const { emailsCliente } = values;
    emailsCliente.splice(index, 1);
    handleChange({ target: { id: `emailsCliente${index}`, values: undefined } });
  };

  const handleChangeEnvioEmail = (event) => {
    handleChange(event);

    // Preencher e-mail principal com o e-mail do cliente
    if (!values?.envioAutomaticoCobranca && !values?.emailsCliente[0]?.email) {
      if (values?.cliente?.emailPrincipal) {
        handleChange({ target: { id: 'emailsCliente[0].email', value: values?.cliente?.emailPrincipal } });
      } else {
        handleChange({ target: { id: 'emailsCliente[0].email', value: '' } });
      }
    }
  };

  const getDias = () => {
    const dias = [];

    for (let i = 1; i <= 31; i++) {
      dias.push(<MenuItem value={i}>{i}º dia do mês</MenuItem>);
    }

    return dias;
  };

  return (
    <>
      <FormTitle title="Informações do pagamento" />
      <Grid container spacing={2} className="mt-16">
        <Grid item xs={4}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <InputLabel id="vencimentoCobranca" required shrink>
              Vencimento da cobrança
            </InputLabel>
            <Select
              id="vencimentoCobranca"
              name="vencimentoCobranca"
              label="Vencimento da cobrança *"
              labelId="vencimentoCobranca"
              value={values?.vencimentoCobranca ? values?.vencimentoCobranca : '1'}
              onChange={handleChange}
              onBlur={handleBlur}
              required
              error={errors.vencimentoCobranca}
              helperText={errors.vencimentoCobranca}
              touched={!!errors.vencimentoCobranca}
              notched
            >
              {getDias().map((dia) => dia)}
            </Select>
            <FormHelperText style={{ color: '#f44336' }}>{errors.vencimentoCobranca || ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <SelectInput
              id="formaCobranca"
              name="formaCobranca"
              label="Forma de recebimento"
              labelId="formaCobranca"
              value={values?.formaCobranca}
              onChange={handleChange}
              onBlur={handleBlur}
              required
              error={errors.formaCobranca}
              helperText={errors.formaCobranca}
              touched={!!errors.formaCobranca}
              options={
                values?.cliente?.tipoPessoa !== 'ESTRANGEIRA'
                  ? [
                      { id: 'BOLETO', title: 'Boleto' },
                      { id: 'CARTAO_CREDITO', title: 'Cartão de crédito' },
                      { id: 'CARTAO_DEBITO', title: 'Cartão de débito' },
                      { id: 'CHEQUE', title: 'Cheque' },
                      { id: 'DINHEIRO', title: 'Dinheiro' },
                      { id: 'TED_DOC', title: 'TED/DOC' },
                      { id: 'PIX', title: 'PIX' },
                    ]
                  : [
                      { id: 'CARTAO_CREDITO', title: 'Cartão de crédito' },
                      { id: 'CARTAO_DEBITO', title: 'Cartão de débito' },
                      { id: 'CHEQUE', title: 'Cheque' },
                      { id: 'DINHEIRO', title: 'Dinheiro' },
                      { id: 'TED_DOC', title: 'TED/DOC' },
                      { id: 'PIX', title: 'PIX' },
                    ]
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <TextLabel
            id="valorContratado"
            label="Valor mensal contratado (R$)"
            value={values?.valorContratado ? getCurrency(values?.valorContratado) : '-'}
          />
        </Grid>
        <Grid item xs={2}>
          <TextLabel
            id="valor"
            label="Valor mensal atual (R$)"
            value={values?.valor ? getCurrency(values?.valor) : '-'}
          />
        </Grid>
      </Grid>

      <RecebimentoDiferentePrimeiraCobranca
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        errors={errors}
      />

      <Grid container spacing={3} className="mt-16 mb-16">
        <Grid item xs={12}>
          <Tooltip
            open={!values?.envioAutomaticoCobranca && openTooltipEnvioAutomatico}
            onClose={handleCloseAutomatico}
            onOpen={handleOpenAutomatico}
            title="Com este recurso você poderá automatizar o envio da fatura e nota fiscal para seu cliente."
            placement="top-start"
          >
            <FormControlLabel
              label="Envio automático"
              control={
                <Switch
                  id="envioAutomaticoCobranca"
                  name="envioAutomaticoCobranca"
                  value={values?.envioAutomaticoCobranca}
                  checked={values?.envioAutomaticoCobranca}
                  onChange={handleChangeEnvioEmail}
                  onBlur={handleBlur}
                  size="small"
                  color="primary"
                />
              }
            />
          </Tooltip>
        </Grid>
        {values?.envioAutomaticoCobranca && (
          <Grid item xs={12}>
            <div id="hintEnvioNF">
              <p>O envio da Nota Fiscal seguirá a opção de faturamento automático marcada nos parâmetros de receita.</p>
              <p>
                O envio da cobrança acontecerá 10 dias antes da data do vencimento. Fique atento com a geração da
                remessa.
              </p>
            </div>
          </Grid>
        )}
      </Grid>

      {/* RNE-504 */}
      {values?.envioAutomaticoCobranca && (
        <>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    id="enviarCobrancaEmail"
                    name="enviarCobrancaEmail"
                    value={values?.enviarCobrancaEmail}
                    checked={values?.enviarCobrancaEmail}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                }
                label="Enviar cobrança por e-mail"
              />
            </Grid>
            <Grid item xs={9}>
              <Tooltip
                open={!faturamentoAutomatico && openTooltipEnvioNF}
                onClose={handleCloseNF}
                onOpen={handleOpenNF}
                title="O envio automático da Nota Fiscal só é possível quando o faturamento é automático."
                placement="top"
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      id="enviarNotaFiscalEmail"
                      name="enviarNotaFiscalEmail"
                      value={values?.enviarNotaFiscalEmail}
                      checked={values?.enviarNotaFiscalEmail}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={!faturamentoAutomatico}
                    />
                  }
                  label="Enviar Nota Fiscal por e-mail"
                />
              </Tooltip>
            </Grid>
            <Grid item xs={5}>
              <TextInput
                fullWidth
                id="emailsCliente[0].email"
                label="E-mail principal do cliente"
                required
                type="email"
                variant="outlined"
                value={values?.emailsCliente[0].email}
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={100}
                error={errors.emailsCliente[0]?.email}
                helperText={errors.emailsCliente[0]?.email}
                touched={!!errors.emailsCliente[0]?.email}
              />
            </Grid>
          </Grid>

          {values?.emailsCliente?.length > 1 &&
            values.emailsCliente.map((emailCliente, index) => {
              return (
                index > 0 && (
                  <Grid container spacing={3} className={index === 2 ? 'mb-16' : ''}>
                    <Grid item xs={5}>
                      <TextInput
                        fullWidth
                        id={`emailsCliente[${index}].email`}
                        label="E-mail adicional"
                        type="email"
                        variant="outlined"
                        value={emailCliente.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        maxLength={100}
                        error={errors.emailsCliente[index]?.email}
                        helperText={errors.emailsCliente[index]?.email}
                        touched={!!errors.emailsCliente[index]?.email}
                      />
                    </Grid>
                    <Tooltip title="Remover e-mail" placement="right-end">
                      <IconButton onClick={() => removeEmail(index)}>
                        <MdHighlightOff size={18} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )
              );
            })}

          {values?.emailsCliente?.length < 3 && (
            <Grid container spacing={3} className="mb-16">
              <Grid item xs={12}>
                <button className={styles.buttonAdicionarEmail} type="button" href="" onClick={addEmail}>
                  Adicionar e-mail
                </button>
              </Grid>
            </Grid>
          )}
        </>
      )}
    </>
  );
};

export default PagamentoContrato;
